import * as React from "react";

import Box from "@material-ui/core/Box";

interface Props {
  children: React.ReactNode;
  // All other props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

export const Container = ({ children, ...rest }: Props): JSX.Element => (
  <Box maxWidth={{ sm: 720, md: 1236 }} width={1} margin="0 auto" {...rest}>
    <Box mx={2} my={{ xs: 1, sm: 2, md: 3 }}>
      {children}
    </Box>
  </Box>
);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Container.tsx